/* eslint-disable react/jsx-boolean-value */
import React from 'react'
import { withStyles } from '@material-ui/styles'
import { Tabs, Tab } from '@material-ui/core'
import omit from 'lodash/omit'
import { rutgersTabsStyles, rutgersTabStyles } from './RutgersTabsStyles'

// Keep the level2 prop out of the rendered HTML
export const RutgersTabs = withStyles(rutgersTabsStyles)((props) => (
  <Tabs
    {...omit(props, ['level2'])}
    TabIndicatorProps={{ children: <span /> }}
  />
))

export const RutgersTab = withStyles(rutgersTabStyles)((props) => (
  <Tab {...props} />
))
